// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllDownloadsIcon__container-b16240 {
  max-width: 32px;
  min-width: 32px;
  height: 32px;
  padding: 4px 7px 6px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.AllDownloadsIcon__icon-wrapper-ebd2a9 {
  min-width: 16px;
  min-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.AllDownloadsIcon__icon-e7d58a {
  fill: var(--base-80);
  vertical-align: middle;
}

.AllDownloadsIcon__bar-c97e79 {
  background-color: var(--base-30);
  width: 100%;
  height: 4px;
  border-radius: 5px;
  overflow: hidden;
  transition: height 0.15s ease;
  will-change: height;
}

.AllDownloadsIcon__bar-c97e79.AllDownloadsIcon__download-ended-e53ddd {
  height: 2px;
  background-color: var(--base-80);
}

.AllDownloadsIcon__progress-bar-d22243 {
  width: 0;
  height: 100%;
  background-color: var(--brand-primary-40);
  will-change: width;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/AllDownloads/AllDownloadsIcon/AllDownloadsIcon.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,oBAAA;EACA,sBAAA;AACF;;AAEA;EACE,gCAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,gCAAA;AACF;;AAEA;EACE,QAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;AACF","sourcesContent":[".container {\n  max-width: 32px;\n  min-width: 32px;\n  height: 32px;\n  padding: 4px 7px 6px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.icon-wrapper {\n  min-width: 16px;\n  min-height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  fill: var(--base-80);\n  vertical-align: middle;\n}\n\n.bar {\n  background-color: var(--base-30);\n  width: 100%;\n  height: 4px;\n  border-radius: 5px;\n  overflow: hidden;\n  transition: height 0.15s ease;\n  will-change: height;\n}\n\n.bar.download-ended {\n  height: 2px;\n  background-color: var(--base-80);\n}\n\n.progress-bar {\n  width: 0;\n  height: 100%;\n  background-color: var(--brand-primary-40);\n  will-change: width;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AllDownloadsIcon__container-b16240`,
	"icon-wrapper": `AllDownloadsIcon__icon-wrapper-ebd2a9`,
	"iconWrapper": `AllDownloadsIcon__icon-wrapper-ebd2a9`,
	"icon": `AllDownloadsIcon__icon-e7d58a`,
	"bar": `AllDownloadsIcon__bar-c97e79`,
	"download-ended": `AllDownloadsIcon__download-ended-e53ddd`,
	"downloadEnded": `AllDownloadsIcon__download-ended-e53ddd`,
	"progress-bar": `AllDownloadsIcon__progress-bar-d22243`,
	"progressBar": `AllDownloadsIcon__progress-bar-d22243`
};
module.exports = ___CSS_LOADER_EXPORT___;
